import { SWRConfig } from "swr";

import PurposeAndGuidelines from "../src/views/PurposeAndGuidelines";
import fetchAPI from "@/components/fetchAPI";
import dirtyHands from "@/public/static/images/dirty-hands.jpg";
import SEOTags from "../components/SEOTags";
import buildAbsoluteURL from "@/components/buildAbsoluteURL";

export async function getServerSideProps(context) {
  const slug = "purpose-and-community-guidelines";
  const queryKey = "/api/content-pages/?slug=" + slug;
  const content = await fetchAPI(queryKey, {}, context);

  return {
    props: {
      fallback: {
        [queryKey]: content,
      },
    },
  };
}

export default function PrivacyPolicyPage({ fallback }) {
  return (
    <SWRConfig value={{ fallback }}>
      <SEOTags
        title="Purpose and Community Guidelines"
        imageLink={buildAbsoluteURL(dirtyHands.src)}
        description="Learn about why we made Thrivespring"
      />
      <PurposeAndGuidelines />
    </SWRConfig>
  );
}
